export default "__VITE_ASSET__Bhwep8Tr__"